<script>
import RentalFileService from '@/services/rentalModule/RentalFileService'
import { displayToast, checkPermission } from '@/components/utils/globalFunction'
import RentalFileStatusConstant from '@/constants/rentalModule/rentalFileStatusConstant'
import CommentaryRentalFile from '@/components/rental-module/rental-file-detail/CommentaryRentalFile.vue'
import AttachmentRentalFile from '@/components/rental-module/rental-file-detail/AttachmentRentalFile.vue'
import GlobalRentalFileInfo from '@/components/rental-module/rental-file-detail/GlobalRentalFileInfo.vue'
import TransportInfosRentalFile from '@/components/rental-module/rental-file-detail/TransportInfosRentalFile.vue'
import DaySuppCounterRentalFile from '@/components/rental-module/rental-file-detail/DaySuppCounterRentalFile.vue'

export default {
  name: 'RentalFileDetailPage',
  components: { GlobalRentalFileInfo, AttachmentRentalFile, CommentaryRentalFile, TransportInfosRentalFile, DaySuppCounterRentalFile},
  data() {
    return {
      loading: false,
      error: null,

      currentRentalFileSummary: null
    }
  },
  async created() {
    await this.getRentalFileSummary()
  },
  methods: {
    checkPermission,
    async getRentalFileSummary() {
      try {
        this.currentRentalFileSummary =
          await RentalFileService.getRentalFileSummary(this.$route.params.rentalFileId)
      } catch (error) {
        this.$router.push({ name: 'Dashboard' })
        displayToast(this.$t('RENTAL_FILE_DETAIL.NOT_FOUND'), 'error')
      }
    },
    getFormatedFullName(fullName) {
      const words = fullName.split(' ')
      let initials = ''
      initials += words[0].charAt(0).toUpperCase() + '.'

      return initials + words[1]
    },
    getStatusTranslation(status) {
      switch (status) {
        case RentalFileStatusConstant.CREATED:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.CREATED')
        case RentalFileStatusConstant.CONTRACT_SENT:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.CONTRACT_SENT')
        case RentalFileStatusConstant.PACKET_PREPARATION:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.PACKET_PREPARATION')
        case RentalFileStatusConstant.TRANSPORT_GO:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.TRANSPORT_GO')
        case RentalFileStatusConstant.CLIENT_RECEIPT:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.CLIENT_RECEIPT')
        case RentalFileStatusConstant.CLIENT_INFORMED:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.CLIENT_INFORMED')
        case RentalFileStatusConstant.STORE_RECEIPT:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.STORE_RECEIPT')
        case RentalFileStatusConstant.TRANSPORT_BACK:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.TRANSPORT_BACK')
        case RentalFileStatusConstant.BOOMERANG_RECEIPT:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.BOOMERANG_RECEIPT')
        case RentalFileStatusConstant.BILLING:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.BILLING')
        case RentalFileStatusConstant.CLOSED:
          return this.$t('RENTAL_FILE_DETAIL.STATUS.CLOSED')
        default:
          this.$router.push({ name: 'Dashboard' })
          displayToast(this.$t('RENTAL_FILE_DETAIL.STATUS_UNKNOWN'), 'error')
      }
    },
    backToDashboard() {
      this.$router.push('/dashboard')
    },
    handleUpdateRentalFile() {
      this.getRentalFileSummary()
    },
    redirectToRepairFileDetail() {
      this.$router.push('/repair-file-detail/' + this.currentRentalFileSummary.repair_file_boomerang_id)
    }
  }
}
</script>

<template>
  <v-container v-if='currentRentalFileSummary' fluid>
    <v-row>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" md="4">
            <div class="title-content">
              <p class="boomerang-id">
                {{ $t('RENTAL_FILE_DETAIL.BOOMERANG_ID') + currentRentalFileSummary.rental_file_boomerang_id }}
              </p>
              <p class="collaborator">
                {{ getFormatedFullName(currentRentalFileSummary.requestor_full_name) }}
              </p>
            </div>
          </v-col>
          <v-col cols="12" md="8">
            <div class="rounded-xl header-info">
              <p class="store-name">
                {{ $t('RENTAL_FILE_DETAIL.STORE') + currentRentalFileSummary.store_name }}
              </p>
              <p class="bold-text">
                {{ $t('RENTAL_FILE_DETAIL.CLIENT_COMPANY_NAME') + currentRentalFileSummary.client_company_name }}
              </p>
              <p class="bold-text">
                {{ $t('RENTAL_FILE_DETAIL.CLIENT_NAME') + currentRentalFileSummary.client_name }}
              </p>
              <p class="creation-date">{{ currentRentalFileSummary.send_date }}</p>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12" md="10">
            <div class="status-content">
              {{ getStatusTranslation(currentRentalFileSummary.rental_file_status) }}
            </div>
          </v-col>
          <v-col class="d-flex justify-end" cols="12" md="2">
            <div class="button">
              <button @click="backToDashboard()">
                <img alt="cross-svg"
                     class="close-btn"
                     src="@/assets/icons/file/cross.svg" />
              </button>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="2" class="pb-0 pt-0">
        <div class="header-rental-container">
          <div class="repair pl-3 pr-3"
               @click="redirectToRepairFileDetail()">
            {{ $t('REPAIR_FILE_DETAIL.HEADER_RENTAL.REPAIR') }}
          </div>
          <div class="rental rental-selected pl-3 pr-3">
            {{ $t('REPAIR_FILE_DETAIL.HEADER_RENTAL.RENTAL') }}
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12">
            <GlobalRentalFileInfo
              :rentalFileId="currentRentalFileSummary.rental_file_technical_id"
              @updateRentalFile="handleUpdateRentalFile()"
            />
          </v-col>
          <v-col cols="12">
            <AttachmentRentalFile
              :rentalFileSummary="currentRentalFileSummary"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <CommentaryRentalFile
              :rentalFileSummary="currentRentalFileSummary"
            />
          </v-col>
          <v-col cols="12">
            <DaySuppCounterRentalFile
              :rentalFileSummary="currentRentalFileSummary"
            />
          </v-col>
          <v-col cols="12">
            <TransportInfosRentalFile
              :rentalFileSummary="currentRentalFileSummary"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.v-container {
  padding: 50px 40px 40px;
}

.title-content {
  display: flex;
  align-items: baseline;
  gap: 20px;
}

.collaborator {
  text-transform: capitalize;
  color: #ACACAC;
  text-align: center;
  padding: unset;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  alignment-baseline: baseline;
}

.boomerang-id {
  padding: unset;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.header-info {
  .v-container {
    padding: 50px 40px 40px;
  }

  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
  align-items: center;
  background: #FFF;
}

.store-name {
  margin-left: 0;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.bold-text {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  text-transform: capitalize;
}

.creation-date {
  color: #ACACAC;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.status-content {
  color: black;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  border: white;
  background: white;
}

.button {
  display: flex;
}

.close-btn {
  display: flex;
  padding: 10px;
  background: white;
  border-radius: 60px;
}

.header-rental-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  background-color: #86C94E;
  border-radius: 100px;
  padding: 10px;
  min-width: 200px;

  .repair {
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    padding: 5px 20px 5px 20px;
    border-radius: 50px;
    gap: 10px;
  }

  .rental {
    cursor: default;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    padding: 5px 20px 5px 20px;
    border-radius: 50px;
    gap: 10px;
  }

  .rental-selected {
    background-color: #FFFFFF;
  }
}
</style>
